<template>
  <div>
      <div id="teamMemberRestrictionPopup" class="modal custom" role="dialog">
      <div class="modal-dialog request-modal">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" @click="loadLogOut()">&times;</button>
              <div class="p-confirm">
                <div>
                  <img src="/static/images/icons/expiry.svg" class="check_img" />
                  <h3 class="confirm_title">Your account has been blocked.</h3>
                </div>
                <div>Please contact your Account Owner.</div>
              </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn emergo-blue-button" @click="loadLogOut()">Okay</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';

export default {
  props: {},
  data() {
    return {
    };
  },

  methods: {
    loadLogOut() {
      socket.removeAllListeners(`alertSaveMultiRegistrationDetails_${localStorage.getItem('userId')}`);
      document.cookie = 'Authorization=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      document.cookie = 'redirect_url=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      localStorage.clear();
      sessionStorage.clear();
      $('#teamMemberRestrictionPopup').modal('hide');
      this.$router.push('/login');
    },
  },
  mounted() {
    $('#teamMemberRestrictionPopup').on('hidden.bs.modal', () => {
      $('.modal-backdrop').remove();
    });
  },
};
</script>
<style scoped>
.request-modal {
  width: 35%;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
}
.p-confirm {
  padding: 20px 30px;
}
.check_img {
  width: 50px;
  height: 50px;
}
.confirm_title {
  color: #0b3c61;
  margin: 15px 0px 15px 0px;
}
.custom .close {
  font-size: 25px;
  color: #808080d9 ;
  background-color: #fff;
  top: 0 !important;
  right: 0 !important;
}
.custom .modal-body {
  padding-bottom: 0px;
}
.custom .modal-footer {
  border: none;
  background-color: #fff;
  padding-top: 0px;
}
@media only screen and (max-width: 767px) {
  .request-modal {
    width: auto;
  }
}
@media (min-width: 768px) and (max-width: 1200px) {
  .request-modal {
    width: 60%;
  }
}
</style>
